import { render, staticRenderFns } from "./ToggleSwitch.vue?vue&type=template&id=e40eadfe"
import script from "./ToggleSwitch.vue?vue&type=script&lang=js"
export * from "./ToggleSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports